import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

const ClientMeetings = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();

  const clientData = {
    camargo: {
      name: 'Camargo',
      meetings: [
        {
          id: '13-11-2025',
          date: '13/11/2025',
          title: 'Reunião 13/11/2025'
        },
        {
          id: '20-11-2025',
          date: '20/11/2025',
          title: 'Reunião 20/11/2025'
        },
        {
          id: '27-11-2025',
          date: '27/11/2025',
          title: 'Reunião 27/11/2025'
        },
        {
          id: '03-12-2025',
          date: '03/12/2025',
          title: 'Reunião 03/12/2025'
        },
        {
          id: '12-12-2025',
          date: '12/12/2025',
          title: 'Reunião 12/12/2025'
        },
        {
          id: '26-12-2025',
          date: '26/12/2025',
          title: 'Reunião 26/12/2025'
        }
      ]
    },
    apolar: {
      name: 'Apolar',
      meetings: [
        {
          id: '28-11-2025',
          date: '28/11/2025',
          title: 'Reunião 28/11/2025'
        },
        {
          id: '05-12-2025',
          date: '05/12/2025',
          title: 'Reunião 05/12/2025'
        }
      ]
    },
    lopes: {
      name: 'Lopes',
      meetings: [
        {
          id: 'onboarding',
          date: 'Onboarding',
          title: 'Reunião de Onboarding'
        }
      ]
    },
    paradise: {
      name: 'Paradise',
      meetings: [
        {
          id: 'start',
          date: 'Start',
          title: 'Reunião de Start — Resultado da Implementação'
        },
        {
          id: 'onboarding',
          date: 'Onboarding',
          title: 'Reunião de Onboarding'
        }
      ]
    }
  };

  const client = clientData[clientId];

  if (!client) {
    return (
      <Container>
        <Header>
          <Title>Cliente não encontrado</Title>
        </Header>
      </Container>
    );
  }

  return (
    <Container>
      <BackButton onClick={() => navigate('/clientes')}>
        ← Voltar para Clientes
      </BackButton>

      <Header>
        <Title>{client.name}</Title>
        <Subtitle>Reuniões agendadas</Subtitle>
      </Header>

      <MeetingsGrid>
        {client.meetings.map(meeting => (
          <MeetingCard 
            key={meeting.id}
            onClick={() => navigate(`/clientes/${clientId}/${meeting.id}`)}
          >
            <MeetingIcon>📅</MeetingIcon>
            <MeetingInfo>
              <MeetingDate>{meeting.date}</MeetingDate>
              <MeetingTitle>{meeting.title}</MeetingTitle>
            </MeetingInfo>
            <ArrowIcon>→</ArrowIcon>
          </MeetingCard>
        ))}
      </MeetingsGrid>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  padding: 4rem 2rem;
`;

const BackButton = styled.button`
  background: rgba(100, 182, 255, 0.1);
  border: 1px solid rgba(100, 182, 255, 0.3);
  color: #64B6FF;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 2rem;

  &:hover {
    background: rgba(100, 182, 255, 0.2);
    border-color: rgba(100, 182, 255, 0.6);
    transform: translateX(-4px);
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-family: 'Orbitron', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  background: linear-gradient(135deg, #64B6FF 0%, #34CFEB 50%, #00FFFF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  letter-spacing: 4px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  color: rgba(100, 182, 255, 0.8);
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const MeetingsGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MeetingCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(100, 182, 255, 0.3);
  border-radius: 12px;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(100, 182, 255, 0.1);
    border-color: rgba(100, 182, 255, 0.6);
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(100, 182, 255, 0.2);
  }
`;

const MeetingIcon = styled.div`
  font-size: 2.5rem;
  flex-shrink: 0;
`;

const MeetingInfo = styled.div`
  flex: 1;
`;

const MeetingDate = styled.h3`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 0.5rem;
`;

const MeetingTitle = styled.p`
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  color: rgba(100, 182, 255, 0.7);
`;

const ArrowIcon = styled.div`
  font-size: 1.5rem;
  color: rgba(100, 182, 255, 0.6);
  transition: transform 0.3s ease;

  ${MeetingCard}:hover & {
    transform: translateX(4px);
    color: rgba(100, 182, 255, 1);
  }
`;

export default ClientMeetings;
